import React, {Component} from 'react';
import {Menu, Dropdown, Icon} from 'antd';

import {version} from '../../../package.json'

import './index.css';

class SettingsMenu extends Component {

  state = { visible: false };

  onClick(a, b) {
    if(this.props.onSelect){
      this.props.onSelect(a,b)
    }
  }

  render() {

    const menu = (
      <Menu className="SettingsMenu" theme="dark" mode="vertical" onClick={this.onClick.bind(this)}>
        <Menu.Item key="reset">Reset Selections</Menu.Item>
        <Menu.Item key="data">CMS Data Source</Menu.Item>
        <Menu.Item key="bnl">BNL Consulting</Menu.Item>
        <Menu.Divider/>
        <Menu.ItemGroup key="version" title={`v${version}`}/>
      </Menu>
    );

    return (
      <Dropdown className="SettingsMenu" overlay={menu}>
        <Icon className="trigger" type="setting"/>
      </Dropdown>
    );
  }
}

export default SettingsMenu;



// WEBPACK FOOTER //
// ./src/components/SettingsMenu/index.js